module.exports = __webpack_public_path__ + "img/penEdicion.69b12647.svg";